import React, { useState, useEffect, useRef } from "react";
import { Route, BrowserRouter as Router } from "react-router-dom";
import Loading from "../shared/loading/Loading";
import NSCApp from "./NSCApp";
import AccessDeniedAsBevDisabled from "../components/accessDenied/AccessDeniedAsBevDisabled";
import CRCApp from "./CRCApp";
import POApp from "./POApp";
import DealerApp from "./DealerApp";
import FieldViewApp from "./FieldViewApp";
import { ofType } from "../common/PubSub";
import { I18nextProvider } from "react-i18next";
import i18n from "../common/i18n";
import { initDynatrace } from "../shared/services/dynatrace/DynatraceService";

let loadingCount = 0;

export function hideOrShow(show, setZIndex = false) {
  if (show === "reset") {
    loadingCount = 0;
    if (document.getElementById("loading"))
      document.getElementById("loading").style.display = "none";
    if (document.getElementById("appWrapper")) {
      document.getElementById("appWrapper").style.zIndex = "auto";
    }
    return;
  }

  if (show) {
    loadingCount += 1;
    if (document.getElementById("loading"))
      document.getElementById("loading").style.display = "block";
    if (document.getElementById("appWrapper") && setZIndex) {
      document.getElementById("appWrapper").style.zIndex = "-1";
    }
  } else {
    if (loadingCount === 1) {
      if (document.getElementById("loading"))
        document.getElementById("loading").style.display = "none";
      if (
        document.getElementById("appWrapper") &&
        (document.getElementById("appWrapper").style.zIndex === "-1" ||
          document.getElementById("appWrapper").style.zIndex === -1)
      ) {
        document.getElementById("appWrapper").style.zIndex = "auto";
      }
    }
    if (loadingCount > 0) loadingCount -= 1;
  }
}

function App({ token: initialToken = null, userDetails: initialUserDetails = null }) {
  const [fromNscDealerSearch, setFromNscDealerSearch] = useState(false);

  const i18nRef = useRef(null);
  if (!i18nRef.current) {
    i18nRef.current = i18n(initialToken);
  }
  const userDetailsRef = useRef(initialUserDetails);

  useEffect(() => {
    initDynatrace();
  }, []);

  useEffect(() => {
    const sub = ofType("nscDealerSearch").subscribe((response) => {
      setFromNscDealerSearch(response.data);
    });
    return () => {
      if (sub?.unsubscribe) sub.unsubscribe();
    };
  }, []);

  const isNsc = (userDetails) => userDetails.userType === "nsc";
  const isDealer = (userDetails) => userDetails.userType === "dealer";
  const isCrc = (userDetails) => userDetails.userType === "crc";
  const isPo = (userDetails) => userDetails.userType === "po";
  const isFieldView = (userDetails) => userDetails.userType === "field_view";

  if (!initialToken || !initialUserDetails) {
    return <Loading />;
  }

  return (
    <I18nextProvider i18n={i18nRef.current}>
      <Router>
        <Loading brand={userDetailsRef.current && userDetailsRef.current.brand} />
        <Route
          render={(props) => {
            if (isDealer(userDetailsRef.current)) {
              return (
                <DealerApp
                  {...props}
                  isNsc={false}
                  i18n={i18nRef.current}
                  userDetails={userDetailsRef.current}
                  hideOrShow={hideOrShow}
                  fromNscDealerSearch={fromNscDealerSearch}
                />
              );
            } else if (isNsc(userDetailsRef.current)) {
              return (
                <NSCApp
                  {...props}
                  isNsc={true}
                  i18n={i18nRef.current}
                  userDetails={userDetailsRef.current}
                  fromNscDealerSearch={fromNscDealerSearch}
                  hideOrShow={hideOrShow}
                />
              );
            } else if (isCrc(userDetailsRef.current)) {
              return (
                <CRCApp
                  {...props}
                  hideOrShow={hideOrShow}
                  i18n={i18nRef.current}
                  fromNscDealerSearch={fromNscDealerSearch}
                  userDetails={userDetailsRef.current}
                />
              );
            } else if (isPo(userDetailsRef.current)) {
              return (
                <POApp
                  {...props}
                  i18n={i18nRef.current}
                  userDetails={userDetailsRef.current}
                  fromNscDealerSearch={fromNscDealerSearch}
                  hideOrShow={hideOrShow}
                />
              );
            } else if (isFieldView(userDetailsRef.current)) {
              return (
                <FieldViewApp
                  {...props}
                  i18n={i18nRef.current}
                  userDetails={userDetailsRef.current}
                  hideOrShow={hideOrShow}
                />
              );
            } else {
              if (document.getElementById("loading")) {
                return <AccessDeniedAsBevDisabled {...props} />;
              } else {
                return null;
              }
            }
          }}
        />
      </Router>
    </I18nextProvider>
  );
}

export default App;
